import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/*
 * @Author: wangshengqiang
 * @Date: 2021-04-22 16:01:05
 * @LastEditTime: 2022-01-10 16:51:38
 * @LastEditors: wangshengqiang
 * @Description: 基础-验证码组件
 */
import React, { useRef, useImperativeHandle } from 'react';
import { Input } from 'zarm';
import Ticktock from './Ticktock';
import './index.less';
const VerifyCode = /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const ticktockRef = useRef();
  const {
    value,
    onChange,
    onGetCode,
    text = '获取验证码'
  } = props;
  const inputProps = {
    inputType: 'text',
    placeholder: '请输入验证码',
    maxLength: 6,
    value,
    onChange
  };
  useImperativeHandle(ref, () => _objectSpread({}, ticktockRef.current));
  return /*#__PURE__*/React.createElement("div", {
    className: "verify-code-container"
  }, /*#__PURE__*/React.createElement(Input, inputProps), /*#__PURE__*/React.createElement("div", {
    className: "get-code-btn"
  }, /*#__PURE__*/React.createElement(Ticktock, {
    ref: ticktockRef,
    className: "input-btn",
    onClick: onGetCode
  }, text)));
});
export default VerifyCode;